// Frittstående ESO-panel (poppet ut til egen skjerm). Egen WS-feed (cookie-auth);
// enkeltmanns-status + sjekkliste-tildelinger flyter via hubbens collab-fanout
// (org-scope). Nyeste-per-soldat / nyeste-per-tildeling flettes lokalt.
import { EsoSoldierStatusSchema, ChecklistAssignmentSchema, type EsoSoldierStatus, type ChecklistAssignment } from '@skade/contracts';
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { EsoPanel } from '../ui/eso.js';

export function mountEsoPanel(root: HTMLElement, feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const statuses = new Map<string, EsoSoldierStatus>();
  const assigns = new Map<string, ChecklistAssignment>();
  const upsertStatus = (s: EsoSoldierStatus) => {
    const e = statuses.get(s.soldierId);
    if (!e || s.tsMs >= e.tsMs) statuses.set(s.soldierId, s);
    if (statuses.size > 2000) { const o = [...statuses.values()].sort((a, b) => a.tsMs - b.tsMs)[0]; if (o) statuses.delete(o.soldierId); }
  };
  const upsertAssign = (a: ChecklistAssignment) => {
    const e = assigns.get(a.id);
    if (!e || a.issuedMs >= e.issuedMs) assigns.set(a.id, a);
    if (assigns.size > 500) { const o = [...assigns.values()].sort((x, y) => x.issuedMs - y.issuedMs)[0]; if (o) assigns.delete(o.id); }
  };
  const panel = new EsoPanel({
    self: { id: user.id, role: user.role, org: user.org },
    getStatuses: () => [...statuses.values()],
    getAssignments: () => [...assigns.values()],
    publishStatus: (s) => { upsertStatus(s); feed.send?.({ type: 'eso', eso: s }); },
    distribute: (a) => { upsertAssign(a); feed.send?.({ type: 'checklist', checklist: a }); },
  }, true);
  root.append(panel.el);
  feed.onCollab?.((m) => {
    if (m.kind === 'eso' && m.eso) { const s = EsoSoldierStatusSchema.safeParse(m.eso); if (s.success) { upsertStatus(s.data); panel.onData(); } }
    else if (m.kind === 'checklist' && m.checklist) { const a = ChecklistAssignmentSchema.safeParse(m.checklist); if (a.success) { upsertAssign(a.data); panel.onData(); } }
  });
  feed.start();
}
